import { User, UserRole } from '../types';

export const isActivationButtonDisabled = (user: User, currentUserRole: string | null): boolean => {
  if (currentUserRole === 'moder') {
    return user.role !== 'user' && user.role !== 'view' && user.role !== 'km' && user.role !== 'to' && user.role !== 'guide';
  }
  if (currentUserRole === 'view' || currentUserRole === 'km' || currentUserRole === 'to') {
    return user.role !== 'user';
  }
  return false;
};

export const logAction = async (action: string): Promise<void> => {
  const currentRole = localStorage.getItem('role') || 'unknown';
  const currentUsername = localStorage.getItem('username') || 'unknown';

  try {
    const { default: axios } = await import('axios');
    await axios.post('https://tbl.zerdegroup.kz/api/log', {
      role: currentRole,
      username: currentUsername,
      action
    });
  } catch (error) {
    console.error('Ошибка при логировании действия:', error);
  }
};

